// TR
export const locale = {
    common: {
        edit: "Düzenle",
        yes: "Evet",
        no: "Hayır",
        new: "Yeni",
        back: "Geri",
        language: "Dil",
        currency: "Para Birimi",
        cancel: "Vazgeç",
        send: "Gönder",
        confirm: "Devam Et",
        date: "Tarih",
        save: "Kaydet",
        report: "Bildir",
        active: "Aktif",
        passive: "Pasif",
        remove: "Sil",
        action: "İşlem",
        search: "Ara",
        close: "Kapat",
        preview: "Önizleme",
        today: "Bugün",
        weekly: "Haftalık",
        monthly: "Aylık",
        yearly: "Yıllık",
        viewAll: "Tümü Gör",
        notification: "Bildirim",
        download: "İndir",
        optional: "İsteğe Bağlı",
        permission: "Yetki",
        manager: "Yönetici",
        default: "Varsayılan",
        status: "Durum",
        sort: "Sırala",
        createdAt: "Oluşturulma Tarihi",
        chooseSelect: "Bir seçim yapın.",
        chooseDate: "Tarih seçin.",
        chooseTime: "Saat seçin.",
        chooseDateAndTime: "Tarih ve saat seçin.",
        selectGroup: "Lütfen bir grup seçin.",
        individual: "Bireysel",
        corporate: "Kurumsal",
        cash: "Peşin",
        system: "Sistem",
        export: "Dışa Aktar",
        overview: "Genel Bakış",
        settings: "Ayarlar",
        enable: "Etkinleştir",
        homePage: "Anasayfa",
        id: "ID",
        true: "Doğru",
        false: "Yanlış",
        hour: "Saat",
        minute: "Dakika",
        second: "Saniye",
        empty: "Boş",
        indefinite: "Süresiz",
        changePassword: "Şifre Değiştir",
        poster: "Öne Çıkan Görsel",
        you: "Sen",
        min: "Minimum",
        max: "Maksimum",
        start: "Başlangıç",
        end: "Bitiş",
        ip: "IP",
        userAgent: "Tarayıcı Bilgisi",
        selfLogin: "Hesaba Giriş Yap"
    },
    impersonation: {
        title: "%s adına görüntülüyorsunuz",
        description: "Yaptığınız işlemler bu müşterinin hesabına işlenir.",
        exit: "Kendi hesabıma dön",
    },
    menu: {
        dashboard: "Gösterge Paneli",
        components: {
            title: "Komponentler",
            custom: {
                title: "Özel",
                table: "Tablo"
            },
            default: {
                title: "Default",
                alert: "Alert",


            },
            primevue: {
                title: "Prime vue",
                form: {
                    title: "Form",
                    editor: "Editor",
                    cascadeSelect: "CascadeSelect",
                    checkbox: "Checkbox",
                    colorPicker: "Color Picker",
                    datePicker: "Date Picker",
                    floatLabel: "FloatLabel",
                    iconField: "IconField",
                    iftaLabel: "IftaLabel",
                    inputGroup: "InputGroup",
                    inputMask: "InputMask",
                    inputNumber: "InputNumber",
                    inputOtp: "InputOtp",
                    inputText: "InputText",
                    keyFilter: "KeyFilter",
                    knob: "Knob",
                    listbox: "Listbox",
                    multiSelect: "MultiSelect",
                    password: "Password",
                    radioButton: "RadioButton",
                    rating: "Rating",
                    select: "Select",
                    selectButton: "SelectButton",
                    slider: "Slider",
                    textarea: "Textarea",
                    toggleButton: "ToggleButton",
                    toggleSwitch: "ToggleSwitch",
                    treeSelect: "TreeSelect",
                },
                button: {
                    title: "Butonlar",
                    button: "Button",
                    speedDial: "Speed Dial",
                    splitButton: "Split Button",
                },
                data: {
                    title: "Data",
                    dataTable: "DataTable",
                    orderList: "OrderList",
                    organizationChart: "Organization Chart",
                    paginator: "Paginator",
                    pickList: "PickList",
                    timeline: "Timeline",
                    tree: "Tree",
                    treeTable: "TreeTable",
                    virtualScroller: "Virtual Scroller",
                },
                panel: {
                    title: "Panel",
                    accordion: "Accordion",
                    card: "Card",
                    deferredContent: "Deferred Content",
                    divider: "Divider",
                    fieldset: "Fieldset",
                    panel: "Panel",
                    scrollPanel: "Scroll Panel",
                    splitter: "Splitter",
                    stepper: "Stepper",
                    tabs: "Tabs",
                    toolbar: "Toolbar",
                },
                overlay: {
                    title: "Overlay",
                    confirmDialog: "Confirm Dialog",
                    confirmPopup: "Confirm Popup",
                    dialog: "Dialog",
                    drawer: "Drawer",
                    dynamicDialog: "Dynamic Dialog",
                    popover: "Popover",
                    tooltip: "Tooltip",
                },
                fileUpload: "File Upload",
                chart: "Chart",
                message: {
                    title: "Messages",
                    message: "Message",
                    toast: "Toast",
                },
                media: {
                    title: "Media",
                    carousel: "Carousel",
                    galleria: "Galleria",
                    image: "Image",
                    imageCompare: "ImageCompare",
                },
                misc: {
                    title: "Misc",
                    animateOnScroll: "AnimateOnScroll",
                    avatar: "Avatar",
                    badge: "Badge",
                    chip: "Chip",
                    focusTrap: "Focus Trap",
                    inplace: "Inplace",
                    meterGroup: "MeterGroup",
                    progressBar: "ProgressBar",
                    progressSpinner: "ProgressSpinner",
                    scrollTop: "ScrollTop",
                    skeleton: "Skeleton",
                    tag: "Tag",
                    terminal: "Terminal",
                },
            },
        },
        pages: {
            title: "Sayfalar",
            library: "Kütüphane",
            store: "Mağaza",
            plan: "Plan Detayım",
            invoices: "Faturalar",
            settings: {
                title: "Ayarlar",
                description: "Hesap, yayın ve sistem yapılandırmasını yönetin.",
                general: {
                    title: "Genel Ayarlar",
                    description: "Hesap bilgileri, dil, saat dilimi ve bakım modu.",
                },
                location: {
                    title: "Lokasyon Ayarları",
                    description: "Yayın bölgeleri, varsayılan lokasyon ve coğrafi kısıtlama.",
                },
                capacity: {
                    title: "Kapasite Ayarları",
                    description: "Depolama, trafik ve yükleme limitleri ile otomatik temizleme.",
                },
                player: {
                    title: "Oynatıcı Ayarları",
                    description: "Varsayılan oynatıcı davranışı, görünüm ve filigran.",
                },
                security: {
                    title: "Güvenlik Ayarları",
                    description: "İmzalı bağlantılar, alan adı kısıtı ve oturum güvenliği.",
                },
                notifications: {
                    title: "Bildirim Ayarları",
                    description: "Hangi olayda hangi kanaldan haber verileceğini belirleyin.",
                },
            },
            userManagement: {
                title: "Kullanıcılar",
                description: "Firmalarınızı ve alt kullanıcılarınızı, yetkileriyle birlikte tek yerden yönetin.",
                company: "Firmalar",
                companyDescription: "Hesabınıza tanımlı firmaları görüntüleyin ve yönetin.",
                user: "Alt Kullanıcılar",
                userDescription: "Alt kullanıcıları oluşturun, yetkilerini ve kapsamlarını belirleyin.",
            },
            developerOptions: {
                title: "Geliştirici Seçenekler",
                apiKeys: "Api Keyler",
            },
            modules: "Modüller",
            user: "Kullanıcılar",
            authentication: {
                title: "Doğrulama",
                signUp: {
                    title: "Kayıt Ol",
                    verify: "Kayıt Doğrulaması"
                },
                passwordReset: {
                    title: "Şifre Sıfırlama",
                    verify: "Şifre Yenileme",
                    confirmation: "Şifre Sıfırlama Onayı",
                },
                twoFactor: "Faktörlü Doğrulama",
                deActive: "Hesabınız Devre Dışı"
            },
            plans: "Planlar & Fiyatlandırma"
        },
        progress: {
            title: "Depolama Alanı",
            upgrade: "Yükselt",
            plan: "Paket",
            storage: "Depolama",
            traffic: "Trafik",
            usagePattern: "%s / %s GB",
            used: "kullanıldı",
        },
        developer: {
            title: "Yönetici İşlemleri",
            description: "Sistem yönetimi, kullanıcı ve operasyon süreçlerini merkezi olarak yönetin.",
            customerManagement: {
                title: "Müşteri Yönetimi",
                description: "Müşteri ve firma ilişkilerini yönetin, kayıtları düzenleyin ve süreçleri tek merkezden takip edin.",
                company: {
                    title: "Şirketler",
                    description: "Şirket bilgilerini yönetin, iş ortaklıklarını düzenleyin ve kurumsal yapıların takibini yapın.",
                },
                customer: {
                    title: "Müşteriler",
                    description: "Müşteri kayıtlarını görüntüleyin, düzenleyin ve müşteri ilişkilerini etkin şekilde yönetin.",
                },
            },
            cdnManagement: {
                title: "CDN Yönetimi",
                description: "CDN altyapınızı yönetin, içerik dağıtım ağlarını optimize edin ve performansı kontrol altında tutun.",

                cdnServer: {
                    title: "CDN Sunucuları",
                    description: "İçerik dağıtımını sağlayan CDN sunucularını görüntüleyin, ekleyin ve yapılandırmalarını yönetin.",
                },

                migrate: {
                    title: "CDN Migrate Görevleri",
                    description: "CDN üzerindeki içerikleri veya yapılandırmaları farklı sunuculara güvenli şekilde taşıma işlemlerini yönetin.",
                },
            },
            videoManagement: {
                title: "Video Yönetimi",
                description: "Video işlemlerini merkezi olarak yönetin ve tüm medya süreçlerini kontrol edin.",
                downloader: {
                    title: "Video İndirme Görevleri",
                    description: "Video kaynaklarını farklı platformlardan indirerek işlenmeye hazır hale getirin."
                },
                converter: {
                    title: "Video Dönüştürme Görevleri",
                    description: "Videoları farklı formatlara dönüştürerek sistem uyumluluğunu sağlayın."
                },
                migrate: {
                    title: "Video Migrate Görevleri",
                    description: "Videoları farklı sunucular veya CDN altyapıları arasında güvenli şekilde taşıyın."
                },
            },
            workerManagement: {
                title: "Görev Yöneticisi",
                description: "Sistem üzerindeki tüm arka plan görevlerini izleyin, yönetin ve performanslarını takip edin.",
                dashboard: {
                    title: "Genel Görünüm",
                    description: "Tüm iş süreçlerinin genel durumunu ve anlık sistem aktivitelerini görüntüleyin."
                },
            },
        }
    },
    messages: {
        warning: "Uyarı",
        success: "Başarılı",
        error: "Hata",
        sureAction: "Bu işlemi gerçekleştirmek istediğinizden emin misiniz? Lütfen dikkatli olun.",
        sureConfirm: "Bu işlemi onaylamak istediğinizden emin misiniz?",
        sureDelete: "Bu kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        actionOk: "İşleminiz başarıyla tamamlandı.",
        deleteOk: "Silme işlemi başarıyla tamamlandı.",
        copyOk: "Kayıt başarıyla kopyalandı. Yeni kaydı kullanmaya başlayabilirsiniz.",
        copyLinkOk: "Link başarıyla kopyalandı.",
        copyLinkError: "Link kopyalanırken bir hata oluştu.",
        selectRow: "Lütfen işlem gerçekleştirmek için bir kayıt seçiniz.",
        wait: "İşleminiz devam ediyor, lütfen bekleyiniz...",
        loading: "Veriler yükleniyor. Lütfen sabırlı olunuz.",
        noResultFound: "Arama kriterlerinize uygun sonuç bulunamadı. Lütfen farklı kriterler kullanarak tekrar deneyiniz."
    },
    btn: {
        new: "Yeni",
        add: "Ekle",
        create: "Oluştur",
        copy: "Kopyala",
        edit: "Düzenle",
        customerDelete: "Müşteriyi Sil",
        delete: "Sil",
        yes: "Evet",
        no: "Hayır",
        cancel: "Vazgeç",
        close: "Kapat",
        refresh: "Yenile",
        update: "Güncelle",
        filter: "Filtrele",
        save: "Kaydet",
        saveAll: "Tümünü Kaydet",
        select: "Seç",
        selectFile: "Dosya Seç",
        upload: "Yükle",
        download: "İndir",
        action: "İşlem",
        previous: "Önceki",
        ensuing: "Sonraki",
        next: "İleri",
        back: "Geri",
        send: "Gönder",
        ok: "Tamam",
        clear: "Temizle",
        tryAgain: "Tekrar Dene",
        apply: "Uygula",
        reset: "Sıfırla",
        change: "Değiştir",
        check: "Kontrol Et",
        clone: "Klonla",
        selectedRowEvent: "Seçili Kayıt İşlemleri"
    },
    datepicker: {
        months: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
        monthsShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
        weekdays: ["Pt", "Sa", "Ça", "Pe", "Cu", "Ct", "Pz"],
    },
    languages: {
        tr: "Türkçe",
        en: "English",
        de: "Deutsch",
    },
    validation: {
        required: "Bu alanı doldurmanız gerekmektedir.",
        email: "Lütfen geçerli bir e-posta adresi giriniz.",
        number: "Bu alana yalnızca sayı değeri girilmelidir.",
        confirmed: "Girdiğiniz bilgiler onay ile eşleşmiyor. Lütfen kontrol edin.",
        length: "Bu alanda en az 2 seçenek bulunmalıdır.",
        password: "Lütfen güçlü ve geçerli bir şifre giriniz.",
        passwordConfirmation: "Lütfen şifrenizi yeniden giriniz.",
        dontMatchPassword: "Girdiğiniz şifreler birbiriyle eşleşmiyor. Lütfen tekrar deneyiniz."
    },
    pages: {
        comingSoon: "Bu sayfa yakında tasarlanacak.",
        store: {
            title: "Mağaza",
            description: "Paketinize ek özellikler tanımlayın; depolama, trafik ve altyapı eklentilerini yönetin.",
            currentPlan: "Mevcut paketiniz",
            planDetail: "Plan Detayı",
            otherPlans: "Diğer Planlar",
            perMonth: "/ay",
            upgrade: "Yükselt",
            cart: "Sepet",
            cartTitle: "Sepetim",
            cartDescription: "Sepetinizdeki eklentileri gözden geçirin, adetleri düzenleyin ve satın alımı tamamlayın.",
            cartEmpty: "Sepetinizde henüz eklenti yok.",
            cartEmptyHint: "Mağazadan ihtiyacınız olan eklentileri sepetinize ekleyebilirsiniz.",
            cartNote: "Eklenti ücretleri mevcut paketinizin faturasına aylık olarak yansıtılır.",
            goToStore: "Mağazaya Git",
            summary: "Sipariş Özeti",
            perUnit: "adet",
            subtotal: "Ara Toplam",
            monthlyRecurring: "Aylık tekrarlayan",
            securePayment: "Ödemeleriniz güvenli altyapı üzerinden işlenir.",
            selectLocation: "Lokasyon Seçin",
            selectedLocations: "%s lokasyon seçildi",
            addToCart: "Sepete Ekle",
            addedToCart: "Eklenti sepetinize eklendi.",
            inCart: "Sepette",
            remove: "Kaldır",
            clearCart: "Sepeti Boşalt",
            continueShopping: "Alışverişe Devam Et",
            checkout: "Ödemeye Geç",
            checkoutSoon: "%s tutarındaki sepetiniz için ödeme adımı yakında eklenecek.",
            total: "Toplam",
            quantity: "Adet",
            quantityHint: "%s x %s kadar ek kapasite tanımlanacak.",
            active: "Aktif",
            multiple: "Çoklu alınabilir",
            locked: "Kilitli",
            unavailable: "Paketiniz Uygun Değil",
            allOwned: "Tümü Alındı",
            alreadyOwned: "Mevcut",
            ownedCount: "%s adet aktif",
            ownedLocations: "%s lokasyon aktif",
            requiresPlan: "Bu eklenti yalnızca %s paketinde kullanılabilir.",
            purchaseQueued: "%s tutarındaki eklenti talebiniz alındı.",
            category: {
                all: "Tümü",
                resource: "Kaynaklar",
                infrastructure: "Altyapı",
                service: "Hizmetler",
            },
            plans: {
                starter: "Starter",
                professional: "Professional",
                enterprise: "Enterprise",
            },
            locations: {
                tr: "Türkiye",
                de: "Almanya",
                uk: "İngiltere",
            },
            note: {
                multiple: "Bu eklentiden dilediğiniz kadar alabilirsiniz; kapasiteler toplanır.",
                upgrade: "Sahip olduğunuz lokasyonlar korunur, yenileri yükseltme olarak eklenir.",
                single: "Bu eklenti hesabınıza yalnızca bir kez tanımlanabilir.",
            },
            addons: {
                storage: {
                    title: "Ek Depolama",
                    description: "Paketinizin depolama alanını genişletin, videolarınız için daha fazla yer açın.",
                },
                traffic: {
                    title: "Ek Trafik",
                    description: "Aylık izlenme trafiğinizi artırın, yoğun dönemlerde kesinti yaşamayın.",
                },
                location: {
                    title: "Yayın Lokasyonları",
                    description: "İçeriklerinizi farklı ülkelerdeki sunuculardan yayınlayın, izleyiciye en yakın noktadan hizmet verin.",
                },
                drm: {
                    title: "DRM Koruması",
                    description: "İçeriklerinizi lisanslı şifreleme ile koruyun, izinsiz indirmeleri engelleyin.",
                },
                prioritySupport: {
                    title: "Öncelikli Destek",
                    description: "Taleplerinize öncelikli sırada yanıt verilir, teknik ekibe doğrudan erişirsiniz.",
                },
                customDomain: {
                    title: "Özel Alan Adı",
                    description: "Video bağlantılarınızı kendi alan adınız üzerinden sunun.",
                },
            },
        },
        plan: {
            title: "Plan Detayım",
            description: "Mevcut paketinizi, kullanım limitlerinizi ve yenileme bilgilerinizi görüntüleyin.",
            active: "Aktif",
            planTagline: "Ekibiniz için gelişmiş yayın ve depolama kapasitesi.",
            monthlyFee: "Aylık paket ücreti",
            renewsAt: "Yenileme tarihi",
            memberSince: "Üyelik başlangıcı",
            upgradePlan: "Planı Yükselt",
            comparePlans: "Planları Karşılaştır",
            cancelPlan: "Planı İptal Et",
            cancelSoon: "Plan iptal akışı yakında eklenecek.",
            cancelHint: "Planınızı iptal ederseniz dönem sonuna kadar kullanmaya devam edersiniz.",
            usage: {
                title: "Kullanım Durumu",
                storage: "Depolama",
                traffic: "Aylık Trafik",
                videos: "Video Sayısı",
                used: "kullanıldı",
                usedLabel: "Kullanılan",
                totalLabel: "Toplam",
                remainingLabel: "Kalan",
                remaining: "%s kaldı",
                unlimited: "Sınırsız",
                resetNote: "Dönem başında sıfırlanır",
            },
            features: {
                title: "Paketinize Dahil",
                storage: "32 GB depolama alanı",
                traffic: "Aylık 500 GB izlenme trafiği",
                hls: "Otomatik HLS dönüşümü ve kalite seçenekleri",
                players: "Sınırsız oynatıcı ve yerleştirme",
                analytics: "Detaylı izlenme raporları",
                support: "7/24 e-posta desteği",
                upload: "Video başına 5 GB yükleme hakkı",
                security: "Alan adı bazlı erişim kontrolü",
            },
            addons: {
                title: "Aktif Eklentiler",
                empty: "Henüz aktif bir eklentiniz yok.",
                goToStore: "Mağazaya Git",
                manage: "Eklentileri Yönet",
                included: "Pakete dahil",
                extra: "Ek eklenti",
                free: "Ücretsiz",
            },
            pendingInvoice: {
                title: "Ödemesi bekleyen faturanız var",
                description: "%s tutarındaki fatura %s tarihine kadar ödenmelidir.",
                action: "Faturayı Öde",
            },
            billing: {
                title: "Aylık Ödeme Özeti",
                planFee: "Paket ücreti",
                addonsFee: "Eklentiler",
                total: "Toplam",
                nextInvoice: "Sonraki fatura",
                viewInvoices: "Faturaları Görüntüle",
            },
        },
        invoices: {
            title: "Faturalar",
            description: "Geçmiş ödemelerinizi ve fatura belgelerinizi görüntüleyin, indirin.",
            detailTitle: "Fatura Detayı",
            detailDescription: "Fatura belgesini görüntüleyin, indirin veya ödemesini tamamlayın.",
            notFound: "Fatura bulunamadı.",
            backToList: "Faturalar",
            pendingAlert: "%s tutarında ödemesi bekleyen %s faturanız var.",
            payAll: "Tümünü Öde",
            cols: {
                number: "Fatura No",
                issuedAt: "Kesim Tarihi",
                dueAt: "Son Ödeme",
                paidAt: "Ödeme Tarihi",
                description: "Açıklama",
                total: "Tutar",
                status: "Durum",
            },
            status: {
                paid: "Ödendi",
                pending: "Bekliyor",
                overdue: "Gecikmiş",
                refunded: "İade Edildi",
                all: "Tümü",
            },
            actions: {
                pay: "Öde",
                view: "Görüntüle",
                download: "İndir",
                print: "Yazdır",
            },
            detail: {
                seller: "Satıcı",
                buyer: "Alıcı",
                ettn: "ETTN",
                issuedAt: "Kesim tarihi",
                dueAt: "Son ödeme tarihi",
                paidAt: "Ödeme tarihi",
                paymentMethod: "Ödeme yöntemi",
                items: "Fatura Kalemleri",
                item: "Kalem",
                quantity: "Adet",
                unitPrice: "Birim Fiyat",
                lineTotal: "Tutar",
                subtotal: "Ara toplam",
                tax: "KDV (%20)",
                total: "Genel Toplam",
                payNow: "Şimdi Öde",
                dueIn: "Son ödeme tarihine %s gün kaldı.",
                overdueBy: "Son ödeme tarihi %s gün önce doldu.",
            },
            payHint: "Ödeme altyapısı entegre edildiğinde bu işlem ödeme sayfasına yönlendirecek.",
        },
        payment: {
            title: "Ödeme",
            cartTitle: "Sepet Ödemesi",
            cartDescription: "Sepetinizdeki eklentilerin ödemesini tamamlayın.",
            invoiceTitle: "Fatura Ödemesi",
            invoiceDescription: "Seçtiğiniz faturaların ödemesini tamamlayın.",
            method: {
                title: "Kartlarım",
                addCard: "Yeni Kart Ekle",
                addCardHint: "Kart bilgilerinizi güvenle saklayın",
                noCard: "Ödeme yapmak için bir kart ekleyin.",
                remove: "Kartı sil",
                edit: "Kartı düzenle",
                expires: "Son kul.",
            },
            card: {
                title: "Yeni Kart Ekle",
                editTitle: "Kartı Düzenle",
                add: "Kartı Ekle",
                update: "Güncelle",
                numberLocked: "Kart numarası değiştirilemez.",
                holder: "Kart Üzerindeki İsim",
                holderPlaceholder: "Ad Soyad",
                number: "Kart Numarası",
                expiry: "Son Kullanma",
                cvv: "CVV",
                save: "Bu kartı sonraki ödemeler için kaydet",
                selectCard: "Bir kart seçin.",
                secure3d: "3D Secure ile öde",
            },
            summary: {
                title: "Ödeme Özeti",
                subtotal: "Ara toplam",
                tax: "KDV (%20)",
                total: "Ödenecek Tutar",
                monthly: "Aylık yinelenen",
                oneTime: "Tek seferlik",
            },
            terms: "Mesafeli satış sözleşmesini okudum ve onaylıyorum.",
            pay: "%s Öde",
            securePayment: "Ödemeniz 256-bit SSL ile korunur.",
            emptyCart: "Sepetiniz boş.",
            goToStore: "Mağazaya Git",
            noInvoice: "Ödenecek fatura bulunamadı.",
            goToInvoices: "Faturalara Git",
            invoiceLine: "%s · %s dönemi",
            successTitle: "Ödeme alındı",
            successCart: "Eklentileriniz hesabınıza tanımlandı.",
            successInvoice: "Faturalarınız ödendi olarak işaretlendi.",
            pendingIntegration: "Ödeme altyapısı entegre edildiğinde bu adımda sanal POS'a yönlendirileceksiniz.",
            validation: {
                holder: "Kart üzerindeki ismi girin.",
                number: "Geçerli bir kart numarası girin.",
                expiry: "Son kullanma tarihini AA/YY biçiminde girin.",
                cvv: "CVV kodunu girin.",
                terms: "Devam etmek için sözleşmeyi onaylayın.",
            },
        },
        settings: {
            title: "Ayarlar",
            description: "Hesap, yayın ve sistem yapılandırmasını tek yerden yönetin.",
            unsaved: "Kaydedilmemiş değişiklikler var.",
            saved: "Ayarlar kaydedildi.",
            general: {
                title: "Genel Ayarlar",
                description: "Hesap bilgileri, dil, saat dilimi ve bakım modu.",
                account: "Hesap Bilgileri",
                regional: "Bölgesel Tercihler",
                maintenance: "Bakım Modu",
                fields: {
                    accountName: "Hesap Adı",
                    accountNameHint: "Faturalarda ve gömme sayfalarında görünen ad.",
                    supportEmail: "Destek E-postası",
                    supportEmailHint: "İzleyici bildirimleri bu adrese yönlendirilir.",
                    language: "Panel Dili",
                    timezone: "Saat Dilimi",
                    timezoneHint: "Rapor ve log kayıtları bu saat dilimine göre gösterilir.",
                    dateFormat: "Tarih Biçimi",
                    weekStart: "Haftanın İlk Günü",
                    maintenanceMode: "Bakım modunu aç",
                    maintenanceModeHint: "Açıkken izleyiciler yayınlara erişemez, panel çalışmaya devam eder.",
                    maintenanceMessage: "İzleyiciye gösterilecek mesaj",
                },
                weekStarts: {
                    monday: "Pazartesi",
                    sunday: "Pazar",
                },
            },
            location: {
                title: "Lokasyon Ayarları",
                description: "Yayın bölgeleri, varsayılan lokasyon ve coğrafi kısıtlama.",
                regions: "Yayın Bölgeleri",
                regionsHint: "Kapalı bölgelerde içerikleriniz saklanmaz; izleyiciye en yakın açık bölgeden yayın yapılır.",
                defaultRegion: "Varsayılan Bölge",
                defaultRegionHint: "Yeni yüklenen videolar önce bu bölgeye yazılır.",
                geo: "Coğrafi Kısıtlama",
                geoHint: "Yayınlarınızın hangi ülkelerden izlenebileceğini belirleyin.",
                latency: "%s ms gecikme",
                included: "Pakete dahil",
                extra: "Ek ücretli",
                setDefault: "Varsayılan yap",
                isDefault: "Varsayılan",
                countries: "Ülkeler",
                geoModes: {
                    off: "Kısıtlama yok",
                    allow: "Yalnızca seçilenler",
                    deny: "Seçilenler hariç",
                },
            },
            capacity: {
                title: "Kapasite Ayarları",
                description: "Depolama, trafik ve yükleme limitleri ile otomatik temizleme.",
                usage: "Mevcut Kullanım",
                limits: "Limitler",
                cleanup: "Otomatik Temizleme",
                storage: "Depolama",
                traffic: "Aylık Trafik",
                usagePattern: "%s / %s",
                fields: {
                    maxUploadSize: "Tek Dosya Yükleme Limiti",
                    maxUploadSizeHint: "Bu boyutun üzerindeki dosyalar reddedilir.",
                    concurrentUploads: "Eşzamanlı Yükleme",
                    concurrentUploadsHint: "Bir kullanıcının aynı anda başlatabileceği yükleme sayısı.",
                    transcodePriority: "Dönüştürme Önceliği",
                    transcodePriorityHint: "Yüksek öncelik, kuyrukta önde işlenir; paket limitine tabidir.",
                    autoCleanup: "Çöp kutusunu otomatik boşalt",
                    autoCleanupHint: "Süresi dolan içerikler kalıcı olarak silinir.",
                    trashRetention: "Saklama Süresi",
                    autoArchive: "Az izlenen videoları arşivle",
                    autoArchiveHint: "Arşivlenen videolar daha yavaş depolamaya taşınır, silinmez.",
                    archiveAfter: "Arşivleme Eşiği",
                },
                priorities: {
                    low: "Düşük",
                    normal: "Normal",
                    high: "Yüksek",
                },
                days: "%s gün",
                daysAfter: "%s gün izlenmezse",
            },
            player: {
                title: "Oynatıcı Ayarları",
                description: "Varsayılan oynatıcı davranışı, görünüm ve filigran.",
                appearance: "Görünüm",
                behaviour: "Davranış",
                watermark: "Filigran",
                preview: "Önizleme",
                previewHint: "Ayarlar yeni gömülen oynatıcılara uygulanır.",
                fields: {
                    accentColor: "Vurgu Rengi",
                    accentColorHint: "İlerleme çubuğu ve düğmelerde kullanılır.",
                    defaultQuality: "Varsayılan Kalite",
                    autoplay: "Otomatik başlat",
                    autoplayHint: "Tarayıcılar sesli otomatik oynatmayı engelleyebilir.",
                    muted: "Sessiz başlat",
                    loop: "Döngüde oynat",
                    controls: "Kontrolleri göster",
                    playbackRates: "Hız seçeneklerini göster",
                    watermarkEnabled: "Filigran ekle",
                    watermarkType: "Filigran Türü",
                    watermarkText: "Filigran Metni",
                    watermarkLogo: "Logo",
                    watermarkLogoHint: "PNG, SVG veya WEBP; saydam zeminli logo en iyi sonucu verir.",
                    watermarkPosition: "Konum",
                    watermarkSize: "Boyutlandırma",
                    watermarkSizeHint: "Oynatıcıya göre oranla ya da sabit piksel ölçüsüyle.",
                    watermarkRatio: "Oran",
                    watermarkPixel: "Ölçü",
                    watermarkPixelHint: "En ve boy, 1280 px genişliğindeki bir oynatıcı için verilir.",
                    watermarkWidth: "En",
                    watermarkHeight: "Boy",
                    watermarkLockRatio: "En/boy oranını koru",
                    watermarkMargin: "Kenar Boşluğu",
                    watermarkOpacity: "Saydamlık",
                },
                watermarkTypes: {
                    text: "Metin",
                    logo: "Logo",
                },
                sizeModes: {
                    percent: "Oransal (%)",
                    pixel: "Piksel",
                },
                previewScaleHint: "Piksel ölçüleri %s px genişliğindeki oynatıcıya göre ölçeklenir.",
                watermarkFile: "Yüklenen logo",
                watermarkDrop: "Logoyu sürükleyin ya da seçmek için tıklayın",
                watermarkDropHint: "PNG, SVG, WEBP veya JPG · en fazla %s MB",
                watermarkTypeError: "Desteklenmeyen dosya türü.",
                watermarkSizeError: "Dosya boyutu en fazla %s MB olabilir.",
                onDark: "Koyu zeminde",
                onLight: "Açık zeminde",
                positions: {
                    "top-left": "Sol üst",
                    "top-right": "Sağ üst",
                    "bottom-left": "Sol alt",
                    "bottom-right": "Sağ alt",
                },
                qualityAuto: "Otomatik",
            },
            security: {
                title: "Güvenlik Ayarları",
                description: "İmzalı bağlantılar, alan adı kısıtı ve oturum güvenliği.",
                playback: "Yayın Güvenliği",
                access: "Panel Erişimi",
                fields: {
                    signedUrls: "İmzalı yayın bağlantıları",
                    signedUrlsHint: "Bağlantılar süreli imzayla üretilir, kopyalanan adres bir süre sonra çalışmaz.",
                    signedUrlTtl: "Bağlantı Geçerlilik Süresi",
                    downloadBlocked: "İndirmeyi engelle",
                    downloadBlockedHint: "Oynatıcıdaki indirme seçeneği kaldırılır.",
                    embedRestriction: "Gömme Kısıtı",
                    allowedDomains: "İzin Verilen Alan Adları",
                    allowedDomainsHint: "Yayınlar yalnızca bu alan adlarında gömülü çalışır.",
                    ipRestriction: "IP kısıtı uygula",
                    ipRestrictionHint: "Panele yalnızca listelenen adreslerden giriş yapılabilir.",
                    allowedIps: "İzin Verilen IP Adresleri",
                    twoFactor: "İki adımlı doğrulamayı zorunlu kıl",
                    twoFactorHint: "Tüm alt kullanıcılar bir sonraki girişte kurulum yapar.",
                    sessionTimeout: "Oturum Zaman Aşımı",
                },
                embedRestrictions: {
                    off: "Kısıt yok",
                    whitelist: "Yalnızca izin verilenler",
                    blacklist: "Engellenenler hariç",
                },
                addDomain: "Alan adı ekle",
                addIp: "IP adresi ekle",
                minutes: "%s dakika",
            },
            notifications: {
                title: "Bildirim Ayarları",
                description: "Hangi olayda hangi kanaldan haber verileceğini belirleyin.",
                matrix: "Olay ve Kanallar",
                webhook: "Webhook",
                webhookUrl: "Webhook Adresi",
                webhookHint: "Seçilen olaylar bu adrese POST edilir.",
                channels: {
                    email: "E-posta",
                    webhook: "Webhook",
                    panel: "Panel",
                },
                events: {
                    videoReady: "Video yayına hazır",
                    videoFailed: "Video işlenemedi",
                    storageThreshold: "Depolama limiti doluyor",
                    trafficThreshold: "Trafik limiti doluyor",
                    invoiceIssued: "Yeni fatura oluştu",
                    userInvited: "Kullanıcı davet edildi",
                    loginFailed: "Başarısız giriş denemesi",
                },
            },
        },
        userManagement: {
            title: "Kullanıcılar",
            description: "Firmalarınızı ve alt kullanıcılarınızı, yetkileriyle birlikte tek yerden yönetin.",
            sections: {
                companyCount: "%s firma",
                userCount: "%s alt kullanıcı",
            },
            company: {
                title: "Firmalar",
                description: "Hesabınıza tanımlı firmaları görüntüleyin ve yönetin.",
                add: "Firma Ekle",
                cols: {
                    name: "Firma Adı",
                    taxNumber: "Vergi No",
                    contact: "Yetkili",
                    email: "E-posta",
                    phone: "Telefon",
                    plan: "Paket",
                    users: "Kullanıcı",
                    status: "Durum",
                },
                noPlan: "Paket yok",
                default: "Varsayılan",
                save: {
                    title: "Firma Detayı",
                    addTitle: "Yeni Firma",
                    description: "Firma bilgilerini, paketini ve bu firmaya bağlı kullanıcıları yönetin.",
                    addDescription: "Yeni firma kaydı oluşturun.",
                    tabs: {
                        general: "Genel Bilgiler",
                        plan: "Paket",
                        users: "Kullanıcılar",
                    },
                    plan: {
                        title: "Aktif Paket",
                        none: "Bu firmaya tanımlı bir paket yok.",
                        started: "Başlangıç",
                        renews: "Yenileme",
                        monthly: "Aylık ücret",
                        usage: {
                            storage: "Depolama",
                            traffic: "Aylık Trafik",
                            videos: "Video Sayısı",
                            usedLabel: "Kullanılan",
                            totalLabel: "Toplam",
                            remainingLabel: "Kalan",
                        },
                        goToPlan: "Plan Detayı",
                        addons: "Eklentiler",
                        noAddons: "Bu pakete tanımlı eklenti yok.",
                        included: "Pakete dahil",
                        extra: "Ek eklenti",
                        free: "Ücretsiz",
                    },
                    created: "Firma oluşturuldu.",
                    newUsersHint: "Kullanıcılar firma kaydedildikten sonra eklenebilir.",
                    addUser: "Kullanıcı Ekle",
                    newPlanHint: "Paket bilgisi firma kaydedildikten sonra görüntülenir.",
                    notFound: "Firma bulunamadı.",
                    backToList: "Firmalar",
                    info: "Firma Bilgileri",
                    users: "Firma Kullanıcıları",
                    emptyUsers: "Bu firmaya bağlı kullanıcı bulunmuyor.",
                    saved: "Firma bilgileri güncellendi.",
                    fields: {
                        name: "Firma Adı",
                        status: "Durum",
                        taxOffice: "Vergi Dairesi",
                        taxNumber: "Vergi No",
                        address: "Adres",
                        city: "Şehir",
                        contact: "Yetkili",
                        email: "E-posta",
                        phone: "Telefon",
                        createdAt: "Kayıt Tarihi",
                        userCount: "Kullanıcı Sayısı",
                    },
                    validation: {
                        name: "Firma adı zorunludur.",
                        taxNumber: "Vergi numarası 10 veya 11 haneli olmalıdır.",
                        email: "Geçerli bir e-posta girin.",
                    },
                },
                view: "Detayı görüntüle",
            },
            user: {
                title: "Alt Kullanıcılar",
                description: "Alt kullanıcıları oluşturun, yetkilerini ve kapsamlarını belirleyin.",
                add: "Alt Kullanıcı Ekle",
                cols: {
                    name: "Ad Soyad",
                    email: "E-posta",
                    permissions: "Yetkiler",
                    company: "Firma",
                    lastLogin: "Son Giriş",
                    status: "Durum",
                },
                never: "Hiç giriş yapmadı",
                owner: "Hesap sahibi",
                editPermissions: "Yetkileri düzenle",
                noPermission: "Yetki yok",
            },
            log: {
                title: "Kullanıcı Logları",
                description: "%s kullanıcısının hesap hareketlerini görüntüleyin.",
                empty: "Bu kullanıcı için kayıt bulunamadı.",
                cols: {
                    createdAt: "Tarih",
                    action: "İşlem",
                    module: "Modül",
                    ip: "IP Adresi",
                    agent: "Cihaz",
                },
                actions: {
                    login: "Giriş yapıldı",
                    loginFailed: "Başarısız giriş",
                    logout: "Çıkış yapıldı",
                    passwordChange: "Şifre değiştirildi",
                    videoUpload: "Video yüklendi",
                    videoUpdate: "Video güncellendi",
                    videoDelete: "Video silindi",
                    folderCreate: "Klasör oluşturuldu",
                    invoiceView: "Fatura görüntülendi",
                    settingsUpdate: "Ayar güncellendi",
                    userCreate: "Kullanıcı eklendi",
                },
                modules: {
                    auth: "Oturum",
                    library: "Kütüphane",
                    invoices: "Faturalar",
                    settings: "Ayarlar",
                    users: "Kullanıcılar",
                },
            },
            edit: {
                title: "Kullanıcıyı Düzenle",
                addTitle: "Yeni Kullanıcı",
                description: "Kullanıcı bilgilerini, yetkilerini ve erişim kapsamını güncelleyin.",
                addDescription: "Firmanıza yeni bir alt kullanıcı ekleyin.",
                created: "Kullanıcı oluşturuldu.",
                notFound: "Kullanıcı bulunamadı.",
                backToList: "Alt Kullanıcılar",
                sections: {
                    profile: "Profil Bilgileri",
                    access: "Erişim",
                    password: "Şifre",
                },
                fields: {
                    firstname: "Ad",
                    lastname: "Soyad",
                    email: "E-posta",
                    phone: "Telefon",
                    company: "Firma",
                    status: "Durum",
                    newPassword: "Yeni Şifre",
                    newPasswordAgain: "Yeni Şifre (Tekrar)",
                },
                passwordHint: "Boş bırakırsanız kullanıcının şifresi değişmez.",
                passwordHintNew: "Kullanıcı bu şifreyle giriş yapacak.",
                newSummaryHint: "Kullanıcı kaydedildikten sonra log kayıtları burada listelenir.",
                summary: "Kullanıcı Özeti",
                lastLogin: "Son giriş",
                userId: "Kullanıcı No",
                permissionSummary: "Yetki",
                editPermissions: "Yetkileri Düzenle",
                viewLogs: "Logları Görüntüle",
                saved: "Kullanıcı bilgileri güncellendi.",
                validation: {
                    firstname: "Ad alanı zorunludur.",
                    lastname: "Soyad alanı zorunludur.",
                    email: "Geçerli bir e-posta girin.",
                    password: "Şifre alanı zorunludur.",
                    passwordLength: "Şifre en az 8 karakter olmalıdır.",
                    passwordMatch: "Şifreler eşleşmiyor.",
                },
            },
            permission: {
                title: "Yetkiler",
                pageTitle: "%s · Yetkiler",
                summaryTitle: "Yetki Özeti",
                backToUser: "Kullanıcı Bilgileri",
                unsaved: "Kaydedilmemiş değişiklikler var.",
                description: "Kullanıcının yapabileceği işlemleri seçin, her yetki için geçerli olacağı kapsamı belirleyin.",
                searchPlaceholder: "Yetki ara",
                summary: "%s / %s yetki",
                groupSummary: "%s / %s",
                selectAll: "Tümünü seç",
                readOnly: "Salt okunur",
                clear: "Temizle",
                fullAccess: "Tam yetki",
                count: "%s yetki",
                scopedCount: "%s kapsamlı",
                more: "+%s",
                none: "Yetki yok",
                empty: "Bu kullanıcıya henüz yetki verilmedi.",
                emptyHint: "Aşağıdaki listeden yetki seçerek başlayın.",
                noResult: "Aramanızla eşleşen yetki bulunamadı.",
                ownerHint: "Hesap sahibi tüm yetkilere sahiptir, yetkileri değiştirilemez.",
                newHint: "Yetkiler kullanıcı kaydedildikten sonra verilebilir.",
                critical: "Hassas yetki",
                incompleteScope: "%s yetkinin kapsamı seçilmedi.",
                saved: "Yetkiler güncellendi.",
                scope: {
                    label: "Kapsam",
                    all: "Tüm hesap",
                    company: "Seçili firmalar",
                    folder: "Seçili klasörler",
                    companyCount: "%s firma",
                    folderCount: "%s klasör",
                    companyPlaceholder: "Firma seçin",
                    folderPlaceholder: "Klasör seçin",
                    allHint: "Hesaptaki tüm firmalar ve klasörler için geçerlidir.",
                    empty: "Kapsam seçilmedi",
                    emptyHint: "Kapsam seçilmeden yetki çalışmaz.",
                    edit: "Kapsamı düzenle",
                    apply: "Uygula",
                    selectAllFolders: "Tümü",
                },
                groups: {
                    library: {
                        title: "Kütüphane",
                        description: "Video ve klasör işlemleri.",
                    },
                    store: {
                        title: "Mağaza",
                        description: "Eklenti ve paket satın alma işlemleri.",
                    },
                    billing: {
                        title: "Faturalar ve Plan",
                        description: "Ödeme, fatura ve plan işlemleri.",
                    },
                    users: {
                        title: "Kullanıcı Yönetimi",
                        description: "Alt kullanıcı ve yetki işlemleri.",
                    },
                    settings: {
                        title: "Ayarlar",
                        description: "Hesap ayarları ve geliştirici seçenekleri.",
                    },
                },
                items: {
                    library: {
                        view: {
                            title: "Kütüphaneyi görüntüle",
                            description: "Klasörleri ve videoları listeleyip izleyebilir.",
                        },
                        upload: {
                            title: "Video yükle",
                            description: "Yeni video yükleyip klasör oluşturabilir.",
                        },
                        edit: {
                            title: "Video düzenle",
                            description: "Video bilgilerini, kapak ve oynatıcı ayarlarını değiştirebilir.",
                        },
                        delete: {
                            title: "Video sil",
                            description: "Video ve klasörleri çöp kutusuna taşıyabilir, kalıcı silebilir.",
                        },
                        share: {
                            title: "Paylaş ve yayınla",
                            description: "Gömme kodu alabilir, paylaşım bağlantısı oluşturabilir.",
                        },
                        download: {
                            title: "Video indir",
                            description: "Videoların kaynak dosyalarını indirebilir.",
                        },
                    },
                    store: {
                        view: {
                            title: "Mağazayı görüntüle",
                            description: "Eklenti ve paketleri inceleyebilir.",
                        },
                        purchase: {
                            title: "Satın alma yap",
                            description: "Sepeti onaylayıp ücretli işlem başlatabilir.",
                        },
                    },
                    billing: {
                        view: {
                            title: "Faturaları görüntüle",
                            description: "Fatura listesini ve fatura detaylarını görebilir.",
                        },
                        pay: {
                            title: "Ödeme yap",
                            description: "Açık faturaları ödeyebilir, kart bilgisi tanımlayabilir.",
                        },
                        plan: {
                            title: "Plan yönetimi",
                            description: "Paket yükseltebilir, düşürebilir veya iptal edebilir.",
                        },
                    },
                    users: {
                        view: {
                            title: "Kullanıcıları görüntüle",
                            description: "Firma ve alt kullanıcı listesini görebilir.",
                        },
                        manage: {
                            title: "Kullanıcı yönet",
                            description: "Alt kullanıcı ekleyebilir, düzenleyebilir ve silebilir.",
                        },
                        permission: {
                            title: "Yetki ver",
                            description: "Diğer kullanıcıların yetki ve kapsamlarını değiştirebilir.",
                        },
                        log: {
                            title: "Logları görüntüle",
                            description: "Kullanıcı hareket kayıtlarını inceleyebilir.",
                        },
                    },
                    settings: {
                        view: {
                            title: "Ayarları görüntüle",
                            description: "Hesap ayarlarını okuyabilir.",
                        },
                        manage: {
                            title: "Ayarları değiştir",
                            description: "Hesap, bildirim ve oynatıcı ayarlarını güncelleyebilir.",
                        },
                        apiKey: {
                            title: "API anahtarları",
                            description: "API anahtarı oluşturabilir ve silebilir.",
                        },
                    },
                },
            },
            status: {
                active: "Aktif",
                passive: "Pasif",
                invited: "Davet edildi",
                all: "Tümü",
            },
        },
        developerOptions: {
            title: "Geliştirici Seçenekler",
            description: "Entegrasyon araçlarını ve geliştirici ayarlarını yönetin.",
            apiKeys: {
                title: "Api Keyler",
                description: "API anahtarlarınızı oluşturun, yetkilendirin ve yönetin.",
                baseUrl: "API Adresi",
                new: "Yeni Anahtar",
                create: "Anahtarı Oluştur",
                copy: "Kopyala",
                copyPrefix: "Anahtar önekini kopyala",
                never: "Hiç kullanılmadı",
                empty: "Henüz API anahtarı oluşturmadınız.",
                namePlaceholder: "Örn. Mobil uygulama",
                expiresAt: "%s tarihinde doluyor",
                revoke: "İptal Et",
                revokeConfirm: "%s anahtarı iptal edilecek. Bu anahtarı kullanan entegrasyonlar çalışmayı durdurur.",
                revoked: "Anahtar iptal edildi.",
                criticalScope: "Hassas",
                scopeRequired: "En az bir yetki seçmelisiniz.",
                createdTitle: "Anahtar Oluşturuldu",
                createdWarning: "Bu anahtar yalnızca bir kez gösterilir. Kapatmadan önce kopyalayıp güvenli bir yerde saklayın.",
                createdDone: "Kopyaladım, kapat",
                usageHint: "İsteklerinizde Authorization başlığıyla gönderin:",
                stats: {
                    total: "Toplam anahtar",
                    active: "Aktif",
                    requests: "Toplam istek",
                },
                cols: {
                    name: "Anahtar Adı",
                    description: "Açıklama",
                    key: "Anahtar",
                    scopes: "Yetkiler",
                    lastUsed: "Son Kullanım",
                    expiry: "Geçerlilik",
                },
                status: {
                    active: "Aktif",
                    expired: "Süresi doldu",
                    revoked: "İptal edildi",
                },
                expiry: {
                    days: "%s gün",
                    never: "Süresiz",
                },
                // vue-i18n noktayı yol ayracı saydığı için yetki anahtarları iç içe tanımlanır
                scopes: {
                    library: {
                        read: "Kütüphane okuma",
                    },
                    video: {
                        upload: "Video yükleme",
                        update: "Video düzenleme",
                        delete: "Video silme",
                    },
                    trash: {
                        manage: "Çöp kutusu yönetimi",
                    },
                    statistics: {
                        read: "İstatistik okuma",
                    },
                },
                scopeDescriptions: {
                    library: {
                        read: "Klasörleri ve videoları listeleyebilir, detaylarını okuyabilir.",
                    },
                    video: {
                        upload: "Yeni video yükleyebilir ve klasör oluşturabilir.",
                        update: "Video bilgilerini ve oynatıcı ayarlarını değiştirebilir.",
                        delete: "Video ve klasörleri çöp kutusuna taşıyabilir.",
                    },
                    trash: {
                        manage: "Çöp kutusundaki içerikleri geri alabilir veya kalıcı silebilir.",
                    },
                    statistics: {
                        read: "Hesap istatistiklerini ve kullanım verilerini okuyabilir.",
                    },
                },
            },
        },
        login: {
            title: "Giriş Yap",
            description: "Sınırsız erişim elde edin ve para kazanın",
            back: {
                title: "Henüz üye olmadın mı?",
                buttonTitle: "Üye Ol"
            },
            cols: {
                customerID: "Müşteri Numarası",
                email: "E - Posta",
                password: "Şifre",
                confirmation: "Giriş yapmanız halinde <a href='https://virtara.tr/kullanim-sartlari-ve-kosullari' target='_blank' class='kt-link text-xs inline'>Kullanım Şartlarını ve Koşullarını</a> kabul etmiş olursunuz."
            },
            successLogin: "Başarıyla giriş yaptınız. Hoş geldiniz!",
            btnText: "Giriş Yap",
            responseMessage: {
                title: "Hata Oluştu",
                invalid_credentials: "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
            },
        },
        auth: {
            banner: {
                title: "ViPanel",
                content: "Yönetim paneli arayüzüne güvenli ve verimli kullanıcı erişimi sağlayan güçlü bir kimlik doğrulama geçidi.",
                theme: {
                    light: "Aydınlık Mod",
                    dark: "Koyu Mod",
                    system: "Otomatik"
                }
            },
            register: {
                title: "Hesap Oluştur",
                description: "Sınırsız erişim elde edin ve para kazanın",
                login: {
                    title: "Zaten üye misiniz?",
                    signIn: "Giriş Yapın"
                },
                cols: {
                    firstname: "Ad",
                    lastname: "Soyad",
                    identificationNumber: "Kimlik No",
                    email: "E-Posta",
                    mobilePhone: "Telefon",
                    birthDate: "Doğum Tarihi",
                    password: "Şifre",
                    passwordConfirmation: "Şifre Tekrar",
                    confirmation: "Giriş yapmanız halinde <a href='https://virtara.tr/kullanim-sartlari-ve-kosullari' target='_blank' class='kt-link text-xs inline'>Kullanım Şartlarını ve Koşullarını</a> kabul etmiş olursunuz."
                },
                sureRegister: {
                    title: "Kaydı tamamlamak istiyor musunuz?",
                    description: "Kayıt olduktan sonra <b>e-posta</b> ve <b>telefon numarasını</b> değiştiremezsiniz, bu yüzden doğru bilgileri girdiğinizden emin olun."
                },
                responseMessage: {
                    success: "Başarılı şekilde kaydınızı tamamladınız! Hoş geldiniz!"
                },
                verify: {
                    title: "E-posta adresinizi doğrulayın",
                    description: "E-posta almadınız mı? <a href='/auth/sign-up' class='kt-link kt-link-underlined kt-link-dashed'>Tekrar Dene</a>",
                    buttonTitle: "Şimdilik Atla"
                }
            },
            passwordReset: {
                title: "Şifrenizi mi unuttunuz?",
                description: "Şifrenizi sıfırlamak için E-posta adresinizi girin.",
                back: {
                    title: "Zaten üye misiniz?",
                    buttonTitle: "Giriş Yap"
                },
                cols: {
                    customerID: "Müşteri Numarası",
                    email: "E-Posta",
                    confirmation: "Giriş yapmanız halinde <a href='https://virtara.tr/kullanim-sartlari-ve-kosullari' target='_blank' class='kt-link text-xs inline'>Kullanım Şartlarını ve Koşullarını</a> kabul etmiş olursunuz."
                },
                responseMessage: {
                    success: "Şifre sıfırlama talimatları e-posta adresinize gönderildi.",
                    password_reset_rate_error: "Şifre sıfırlama talebinizi son talep zamanından 120 saniye sonra yapabilirsiniz."
                },
                verify: {
                    title: "Şifre Yenile",
                    description: "Yeni şifrenizi onay kodu ile birlikte girin.",
                    back: {
                        title: "Zaten üye misiniz?",
                        buttonTitle: "Giriş Yap"
                    },
                    cols: {
                        email: "E-Posta",
                        password: "Şifre",
                        passwordConfirmation: "Şifre Tekrar",
                        code: "Onay Kodu"
                    },
                    responseMessage: {
                        success: "Şifreniz başarıyla sıfırlandı.",
                        invalid_token: "Bu bağlantı geçerliliğini yitirmiş veya daha önce kullanılmış. Lütfen yeni bir bağlantı talep ediniz."
                    }
                },
                confirmation: {
                    title: "Şifreniz başarıyla sıfırlandı.",
                    description: "Yaratıcı olmak için harika bir fırsat <a href='#' class='kt-link kt-link-underlined kt-link-dashed'>max{'@'}keenthemes.com</a> <br>okuyuculara bir fikir veriyor"
                }
            },
            twoFactor: {
                title: "İki Faktörlü Doğrulama",
                description: "Gönderdiğimiz doğrulama kodunu girin",
                phoneFormat: "******7859",
                cols: {
                    code: "6 haneli güvenlik kodunu girin"
                }
            },
            deActive: {
                title: "Hesabınız devre dışı bırakıldı",
                description: "Harika fırsatlar elde edebilirsiniz. Daha fazla bilgi için lütfen bizimle iletişime geçiniz.",
                btnText: "Ana Sayfaya Dön"
            },
        },
        account: {
            overview: {
                title: "Profil Detayları",
                cols: {
                    name: "Ad",
                    surname: "Soyad",
                    email: "E-Posta",
                    phone: "Telefon"
                }
            },
            settings: {
                signInMethod: {
                    title: "Giriş Yöntemi",
                    emailAddress: "E-Posta Adresi",
                    password: {
                        title: "Şifre",
                        cols: {
                            currentPassword: "Mevcut Şifre",
                            password: "Yeni Şifre",
                            passwordConfirmation: "Yeni Şifre Tekrar"
                        },
                        changePassword: "Şifre Değiştir",
                        updatePassword: "Şifreyi Güncelle"
                    }
                }
            }
        },
        dashboard: {},
        video: {
            detail: {
                title: "Video Detayı",
                description: "Video bilgilerini görüntüleyin, düzenleyin ve yayın kaynaklarını yönetin.",
                deleteContent: "İçeriği Sil",
                tab: {
                    general: "Detay",
                    image: "Resimler",
                    video: "Video"
                },
                cols: {
                    title: "Başlık",
                    group: "Video Grubu"
                },
                options: {
                    title: "İşlem Parametreleri",
                    type: {
                        convert_mp4: "MP4 haricindekileri dönüştür",
                        convert_unsupported: "Desteklenmeyenleri MP4'e çevir",
                        convert_hls: "HLS için export oluştur"
                    }
                },
                processState: {
                    title: "İşlem Durumu",
                    type: {
                        CONVERT_HLS: "HLS Dönüşümü",
                        CONVERT_COMPRESSION: "Video Sıkıştırma"
                    }
                },
                extras: {
                    title: "Diğer Bilgiler",
                    sizeChanged: {
                        old: "Orjinal (%s)"
                    }
                },
                copyUrl: {
                    title: "Direk Erişim URL",
                    copied: "Kopyalandı!"
                },
                stream: {
                    title: "Desteklenen Yayınlar",
                    cols: {
                        type: "Tip",
                        size: "Boyut",
                        url: "URL"
                    }
                },
                videoImage: {
                    title: "Video Resimleri",
                    noData: "Bu video için üretilmiş resim bulunmuyor."
                },
                videoTab: {
                    original: "Orijinal",
                    hls: "HLS"
                },
                warning: {
                    videoCompress: {
                        text1: "Video Sıkıştırma işlemi devam ediyor. Bu süreç tamamlandıktan sonra görüntülenen video bilgileri (direk erişim url, thumbnail vb.) değişiklik gösterebilir. Video sıkıştırma işlemi tamamlandıktan sonra nihai bilgiler gösterilecektir.",
                        text2: "Video sıkıştırma işlemi sunucu yoğunluğu, video renk kodlaması vb. gibi durumlara bağlı olarak birkaç saat kadar sürebilir.",
                        videoLink: "Video sıkıştırma işlemi yapıldıktan sonra URL gösterilecektir."
                    }
                }
            }
        },
        library: {
            title: "Kütüphane",
            description: "Dijital içeriklerinizi yükleyin, organize edin ve kolayca yönetin.",
            mainDirectory: "Ana Klasör",
            noData: "Klasörde listelenecek bir veri bulunamadı.",
            downloadNoVideo: "Seçimde indirilebilir video bulunmuyor.",
            downloadStarted: "İndirme hazırlanıyor, dosya boyutuna göre biraz sürebilir.",
            trash: {
                title: "Çöp Kutusu",
                description: "Silinen içerikleri görüntüleyin, kurtarın veya kalıcı olarak silin.",
                warningTitle: "Uyarı",
                warningText: "Silinen içerikler yanlışlıkla yapılan hataları önlemek amacıyla bu sayfada gösterilir ve 7 gün boyunca saklanır. Süre sonunda kalıcı olarak silinir. İçeriği kurtarmak veya kalıcı olarak silmek için aşağıdaki butonları kullanabilirsiniz.",
                noData: "Çöp kutusu boş.",
                remainingPattern: "%s gün",
                confirmRemoveForever: "Seçili içerik(ler) kalıcı olarak silinecek ve geri alınamaz. Devam edilsin mi?",
                cols: {
                    title: "Başlık",
                    detail: "Detay",
                    deletedAt: "Silinme Tarihi",
                    remaining: "Kalan Süre",
                },
                action: {
                    recover: "Kurtar",
                    removeForever: "Kalıcı Olarak Sil",
                },
            },
            type: {
                directory: "Klasör",
                video: "Video",
                void: "Ses",
                image: "Fotoğraf"
            },
            cols: {
                id: "ID",
                title: "Başlık",
                type: "Tür",
                date: "Tarih",
                size: "Boyut",
                sizePattern: "%s Klasör",
                actions: "İşlemler",
            },
            action: {
                sort: "Sırala",
                filter: "Filitre",
                addFolder: "Klasör Ekle",
                updateFolder: "Klasör Düzenle",
                addVideo: "Video Ekle",
                copyLink: "Link Kopyala",
                addFavorite: "Favorilere Ekle",
                removeFavorite: "Favorilerden Çıkart",
                remove: "Çöp Sepetine Taşı",
                move: "Şuraya Taşı",
                clearSelection: "Seçimi Kaldır",
                soundOn: "Sesi Aç",
                soundOff: "Sesi Kapat",
                newFolderName: "Yeniden Adlandır",
                download: "İndir",
                openVideo: "Video Detayı",
                openDirectory: "Klasörü Aç",
                excelExport: "Excel'e Aktar",
            },
            export: {
                preparing: "Excel dosyası hazırlanıyor...",
                failed: "Excel dosyası oluşturulurken bir hata oluştu.",
                empty: "Dışa aktarılacak içerik bulunamadı.",
                includeChildrenQuestion: "Alt klasörlerdeki videolar da dahil edilsin mi?",
                withChildren: "Alt Klasörler Dahil",
                onlyThis: "Sadece Bu Klasör",
                sortQuestion: "Klasör içi sıralama nasıl olsun?",
                selectedSummary: "%s klasör ve %s video seçildi",
            },
            selectionChip: "%s öğe seçildi",
            directory: {
                save: {
                    title: "Klasör Ekle",
                    cols: {
                        title: "Klasör Adı",
                        defaultTitle: "Yeni Klasör",
                    }
                },
                move: {
                    title: "Klasörü Taşı",
                    cols: {
                        title: "Klasör Seç",
                    }
                }
            },
            video: {
                save: {
                    title: "Video Ekle",
                    cols: {
                        video: "Video",
                        title: "Video Başlığı",
                        patternVideoTitle: "%s. Video Başlığı",
                        group: "Video Grubu",
                        convert_hls: "HLS için export oluştur.",
                        convert_unsupported: "Desteklenmeyen videoları otomatik olarak uyumlu formata dönüştür",
                    }
                },
                move: {
                    title: "Video Taşı",
                    cols: {
                        title: "Video Seç",
                    }
                }
            },
            move: {
                title: "Şuraya Taşı",
                cols: {
                    parentId: "Klasör Seç"
                }
            },
        },
        plans: {
            title: "Planlar & Fiyatlandırma",
            description: "İhtiyacınıza en uygun planı seçin, hemen kullanmaya başlayın. Tüm planlarımız esnek ve ölçeklenebilir yapıdadır.",
        },
        developer: {
            customerManagement: {
                company: {
                    title: "Firmalar",
                    description: "Firma bilgilerinizi organize edin, iş ortaklıklarınızı tek bir yerden yönetin.",
                    add: "Firma Ekle",
                    update: "Firma Düzenle",
                    cols: {
                        name: "Firma Adı",
                        usersCount: "Kayıtlı Personel",
                    }
                },
                customer: {
                    title: "Müşteriler",
                    description: "Müşteri kayıtlarınızı görüntüleyin, düzenleyin ve ilişkilerinizi kolayca yönetin.",
                    add: "Müşteri Ekle",
                    update: "Müşteri Düzenle",
                    selfLogin: "Hesabına giriş yap",
                    selfLoginConfirm: "%s adına panele giriş yapılacak. Bu sırada yaptığınız işlemler o müşterinin hesabında görünür.",
                    selfLoginAccept: "Giriş yap",
                    cols: {
                        firstname: "Adı",
                        lastname: "Soyadı",
                        email: "E-Posta Adresi",
                        company: "Şirket",
                        group: "Group",
                        active: "Durum",
                        password: "Şifre",
                    },
                    save: {
                        add: "Müşteri Ekle",
                        update: "Müşteri Detayı",
                        information: "Müşteri Bilgileri",
                        passwordChange: "Şifre Değiştir",
                        is_editable: "Müşteri Düzenlenebilir",
                        is_deletable: "Müşteri Silinebilir",
                        tabs: {
                            detail: "Detay",
                            storage: "Depolama",
                        },
                        cols: {
                        }
                    },
                    changePassword: {
                        title: "Şifre Değiştir",
                        description: "Hesap güvenliğiniz için güçlü ve benzersiz bir şifre belirleyin. Şifrenizi düzenli olarak güncellemeniz önerilir.",
                        btn: "Şifreyi Değiştir",

                    }
                }
            },
            videoManagement: {
                cols: {
                    total: "Toplam",
                    inProcess: "İşlemde",
                    pending: "Bekleyen",
                    completed: "Tamamlanan",
                    progress: "İlerleme",
                    createdAt: "Oluşturulma Tarihi",
                },
                detail: {
                    title: "#%s Görev Detayı",
                    description: "Görevdeki videoların tek tek durumunu ve ilerlemesini izleyin.",
                    summary: "Görev Özeti",
                    items: "Görev Kalemleri",
                    notFound: "Görev bulunamadı.",
                    cols: {
                        videoId: "Video ID",
                        title: "Video",
                        newVideoId: "Yeni Video",
                    },
                },
                converter: {
                    new: "Yeni Dönüştürme Görevi",
                    cols: {
                        convertType: "Dönüşüm Tipi",
                        customer: "Müşteri",
                        selectorType: "Seçim Yöntemi",
                        maxCount: "Video Sayısı",
                        priority: "Öncelik",
                    },
                    selectorType: {
                        random: "Rastgele",
                        createdAsc: "Eklenme Tarihi (Eskiden Yeniye)",
                        createdDesc: "Eklenme Tarihi (Yeniden Eskiye)",
                    },
                },
                migrate: {
                    new: "Yeni Migrate Görevi",
                    cols: {
                        host: "Kaynak Sunucu",
                        bearerToken: "Bearer Token",
                        customers: "Taşınacak Müşteriler",
                        fileLimit: "Eşzamanlı Dosya Limiti",
                        total: "Toplam",
                        inProcess: "İşlemde",
                        pending: "Bekleyen",
                        completed: "Tamamlanan",
                        progress: "İlerleme",
                        createdAt: "Oluşturulma Tarihi",
                    }
                },
            },
            cdnManagement: {
                cdnServer: {
                    detail: "Depolama Detayı",
                    detailDescription: "CDN sunucusundaki depolama alanının bilgilerini ve doluluk durumunu görüntüleyin.",
                    info: "Depolama Bilgileri",
                    notFound: "Depolama alanı bulunamadı.",
                    total: "Toplam Alan",
                    used: "Kullanılan",
                    free: "Boş Alan",
                    cols: {
                        name: "Depolama Adı",
                        server: "CDN Sunucusu",
                        hostname: "Sunucu Adı",
                        host: "Adres",
                        version: "Sürüm",
                        path: "Yol",
                        usage: "Doluluk",
                    },
                },
            },
        }
    },
    filters: {
        invoice: {
            number: "Fatura No",
            status: "Durum",
            dateRange: "Tarih Aralığı",
            startDate: "Başlangıç",
            endDate: "Bitiş",
        },
        title: "Filtre Seçenekleri",
        user: {
            id: "Kullanıcı ID"
        },
        library: {
            id: "ID (Video ya da Klasör)",
            title: "Başlık",
        },
    },
    components: {
        libraryVideo: {
            uploadTitle: "Videoları sürükleyin veya tıklayarak seçin"
        }
    },
    sortFields: {
        title: "Sıralama Seçenekleri",
        video: {
            titleAsc: "Ada Göre (A-Z)",
            titleDesc: "Ada Göre (Z-A)",
            qualityAsc: "Çözünürlük (Küçükten Büyüğe)",
            qualityDesc: "Çözünürlük (Büyükten Küçüğe)",
            durationAsc: "Uzunluk (Küçükten Büyüğe)",
            durationDesc: "Uzunluk (Büyükten Küçüğe)",
            sizeAsc: "Boyut (Küçükten Büyüğe)",
            sizeDesc: "Boyut (Büyükten Küçüğe)",
            createdAtAsc: "Eklenme Tarihi (Eskiden Yeniye)",
            createdAtDesc: "Eklenme Tarihi (Yeniden Eskiye)",
        }
    },
    customTable: {
        noData: "Listelenecek veri bulunamadı.",
        showingPageInformationPattern: "%s kayıttan, %d ile %d arası gösteriliyor"
    },
    userMenu: {
        language: "Dil",
        account: "Hesabım",
        security: "Güvenlik",
        userRoles: "Üyeler & Roler",
        integration: "Entegrasyonlar",
        darkMode: "Koyu Mod",
        signOut: "Çıkış Yap"
    },
    footer: {
        copyrightText: "Virtara Group Bilişim Teknolojileri. Tüm hakları saklıdır."
    },
    endpointActions: {
        get: "Görüntüleme",
        post: "Ekleme",
        put: "Güncelleme",
        delete: "Silme"
    },
    responseErrors: {
        record_not_found: "Kayıt bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen farklı bir kayıt arayınız.",
        method_not_found: "İşlem bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen tekrar deneyin.",
        invalid_file_type: "Geçersiz dosya türü seçildi. Lütfen uygun bir dosya türü kullanınız.",
        current_password_invalid: "Mevcut şifre hatalı. Lütfen doğru şifreyi girip tekrar deneyiniz.",
        this_group_not_usable: "Bu grup şu an kullanılamaz. Lütfen farklı bir grup seçin.",
        invalid_identification_number: "Geçersiz kimlik numarası girildi. Lütfen geçerli bir kimlik numarası kullanınız.",
        validate_error: "Doğrulama hatası oluştu. Lütfen bilgilerinizi kontrol ederek tekrar deneyiniz.",
        provider_handler_not_found_by_code: "Belirtilen koda göre sağlayıcı bulunamadı. Lütfen geçerli bir kod giriniz.",
        video_id_invalid: "Geçersiz video kimliği girdiniz. Lütfen geçerli bir kimlik giriniz.",
        invalid_customer_id: "Müşteri numarası hatalı. Lütfen geçerli bir müşteri numarası ile tekrar deneyiniz.",
        login_description: "Lütfen tarafınıza iletilen yetkili giriş bilgilerini kullanarak oturum açın.",
        login_error: "Giriş bilgilerinizi kontrol edin.",
        invalid_credentials: "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
    }
};
